import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/giftcard.css"
import "../CSS/Template.css"
import Checkbox from '../Components/Checkbox.js';
import AppointmentService from '../utils/AppointmentService.js';
import NewCCForm from '../Components/NewCCForm.js';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import Modal from 'react-modal';
import InfiniteCalendar from 'react-infinite-calendar';
import moment from 'moment'
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
import CustomerInfoForm from '../Components/CustomerInfoForm.js';
import AuthService from '../utils/AuthService.js';
//import 'moment-timezone';
import 'react-infinite-calendar/styles.css';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'
// if (!window.Promise) {
//   window.Promise = Promise;
// }

const override = css`
    display: block;
    margin: 10% 45%;
    border-color: red;
`;

//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'



export class NewGiftcard extends Component {
  constructor(props) {
    super(props)
    var id = props.match.params.image_id
    this.state = {
      image_id: id,
      amount: null,
      message: null,
      sendAt: null,
      cardId: null,
      name: null,
      email:null,
      phone:null,
      user: null,
      creditCardOptions: [],
      creditCard: null,
      newCCmodal: false,
      phoneError: false,
      modalIsOpen: false,
      width: document.body.clientWidth,
      shrink: false,
      open: false,
      color: '#c42d2d',
      loading: false,
      loginError: ''
    }
    this.Auth = new AuthService()
    this.ApptService = new AppointmentService()
    this.closeCCModal = this.closeCCModal.bind(this)
    this.saveCard = this.saveCard.bind(this)
    this.createGiftcard = this.createGiftcard.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.saveUser = this.saveUser.bind(this)
    this.loginUser = this.loginUser.bind(this)
    this.checkForUser = this.checkForUser.bind(this)
    this.setVariables = this.setVariables.bind(this)
    this.saveVariables = this.saveVariables.bind(this)
    this.setLocalStorage = this.setLocalStorage.bind(this)
  }
  componentWillMount() {
    this.ApptService.giftcard_image(this.state.image_id)
    .then(res =>{
      if(res){
        this.setState({
          image: res
        })
        }
      else {
        this.setState({
          errorMessage: "Cannot find the Image."
        })
      }
    })
    this.getCreditCards()
    this.ApptService.getUser()
    .then(res =>{
      if(res){
        this.setState({
          user: res
        })
      }
    })

    if(localStorage.getItem('amount') && localStorage.getItem('image_id') && localStorage.getItem('email') && localStorage.getItem('name') ){
      this.setVariables()
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  handleChange = name => event => {
    var value = event.target.value
    value = value.replace(/(\d{3})\-?(\d{3})\-?(\d{4})/,'$1-$2-$3')
     this.setState({
       [name]: value,
     },function () {
        this.validatePhone()
     });
  };
  validatePhone() {
    if(this.state.phone && (this.state.phone.length !== 10 && this.state.phone.length !== 12)){
      this.setState({
        open: false,
        phoneError: true
      })
    }
    else {
      this.setState({
        open: false,
        phoneError: false
      })
      return true
    }
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }
  closeModal() {
    this.setState({modalIsOpen: false});
  }
  closeCCModal() {
    this.setState({newCCmodal: false});
  }
  refresh() {
    this.setState({});
  }
  saveCard(ccNumber, expMonth, expYear, cvc, cardName, billingZipcode){
    this.setState({
      loading:true,
      newCCmodal: false
    })
    this.ApptService.addCreditCard(ccNumber, expMonth, expYear, cvc, cardName, billingZipcode)
    .then(res =>{
      if(res && res.errors){
        this.setState({
          loading:false,
          newCCmodal: true,
          open: true,
          color: '#c42d2d',
          errorMessage: `Error from saveCard line 149 ${res.errors}`
        })
      }
      else if(res){
        this.setState({
          creditCard: res,
          errorMessage: '',
          open: false
        })
      }
    })
  .catch(err => {
  })

}
  validateFields() {
    document.getElementById("purchaseButton").setAttribute('disabled', 'disabled');
    if (!this.validatePhone()){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Phone Number is invalid',
        loading: false
      })
      document.getElementById("purchaseButton").removeAttribute('disabled');
      return false
    }
    if(!this.state.amount || this.state.amount < 0 || isNaN(this.state.amount)){
      document.getElementById("purchaseButton").removeAttribute('disabled');
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Amount is required and must be a valid number',
        loading: false
      })
      return false
    }
    if(!this.state.name){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Recipient Name is required',
        loading: false
      })
      document.getElementById("purchaseButton").removeAttribute('disabled');
      return false
    }
    if(!this.state.email){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Recipient Email is required and must be valid',
        loading: false
      })
      document.getElementById("purchaseButton").removeAttribute('disabled');
      return false
    }
    if(!(this.state.creditCard.label || this.state.cardId)){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Credit card must be selected',
        loading: false
      })
      document.getElementById("purchaseButton").removeAttribute('disabled');
      return false
    }
    else {
      return true
    }
  }
  loginUser = (username, password) => {
    var guest_id = localStorage.getItem('customer_id')
    this.Auth.merge_guest_and_logn(username, password, guest_id)
      .then(res =>{
        if(res.errors){
          this.setState({
            loginError: "Password is incorrect"
          })
        }
        else {
          localStorage.setItem('id_token', res.auth_token)
          localStorage.setItem('customer_id', res.id)
          this.saveVariables(res)
          this.setState({
            userInfoModalOpen: false,
            user: res
          })
          window.location.reload()
          this.setVariables()
        //  this.createGiftcard()
        }
      })
      .catch(err =>{
        //throw new Error('Error setting default credit card' + err.message);
      })
  }
  setLocalStorage(id, value){
    localStorage.setItem(id, value)
  }
  saveVariables(user) {
    this.setLocalStorage('user', JSON.stringify(user))
    this.setLocalStorage('amount', JSON.stringify(this.state.amount))
    this.setLocalStorage('message', JSON.stringify(this.state.message))
    this.setLocalStorage('name', JSON.stringify(this.state.name))
    this.setLocalStorage('email', JSON.stringify(this.state.email))
    this.setLocalStorage('sendAt', JSON.stringify(this.state.sendAt))
    this.setLocalStorage('image_id', JSON.stringify(this.state.image_id))
    this.setLocalStorage('phone', JSON.stringify(this.state.phone))
  }
  setVariables() {
    this.setState({
      image_id: JSON.parse(localStorage.getItem('image_id')),
      amount: JSON.parse(localStorage.getItem('amount')),
      name: JSON.parse(localStorage.getItem('name')),
      message: JSON.parse(localStorage.getItem('message')),
      sendAt: JSON.parse(localStorage.getItem('sendAt')),
      email: JSON.parse(localStorage.getItem('email')),
      phone: JSON.parse(localStorage.getItem('phone')),
      user: JSON.parse(localStorage.getItem('user')),
    })
  }
  saveUser = (user) => {
    this.setState({
      userInfoModalOpen:false,
      user: user,
      newCCmodal: true
    })
  }
  checkForUser() {

  }
  createGiftcard(){
    if(this.validateFields()){
      this.ApptService.createGiftcard(this.state.amount, this.state.cardId, this.state.name, this.state.email, this.state.phone,this.state.message,this.state.sendAt, this.state.creditCard)
      .then(res =>{
        if(!res.errors){
          this.setState({
            color: 'green',
            open: true,
            errorMessage: 'Giftcard successfully created!',
            amount: '',
            message: '',
            sendAt: '',
            cardId: '',
            name: '',
            email:'',
            phone:'',
            newCCmodal: false,
            loading:false,
            showConfirmationModal: true
          })

          document.getElementById("purchaseButton").disabled = false;
        }
        else {
          this.setState({
            open:true,
            errorMessage: "Error Purchasing Giftcard",
            color: '#c42d2d',
            loading: false,
            newCCmodal: false,
          })
          document.getElementById("purchaseButton").disabled = false;
        }
      })
    }
  }
  returnToDashboard =() => {
    window.location.href = '../giftcards';
  }
  handleCCChange = event => {
    var user = this.state.user
      if(user && (!user.email || !user.first_name || !user.last_name || !user.phone)){
        this.setState({
          userInfoModalOpen: true
        })
      }
    else if(event.value === 'new'){
      this.setState({
        newCCmodal: true
      })
    }
    else{
      this.setState({creditCard: event});
    }
  }
  showCalendar = () => {
    this.setState({
      modalIsOpen:true
    })
  }
  selectDate = (date) => {
      var sendAt = new Date(date)
      var sendAtDate = moment(sendAt).format('MMMM Do YYYY')
      this.setState({
        sendAt: sendAt,
        sendAtFormatted: sendAtDate,
        shrink:true,
        modalIsOpen: false,
      })
  }
  getCreditCards = () => {
    this.ApptService.creditCards()
    .then(res =>{
      if(res.errors){
        this.props.setError("Could not retrieve saved credit cards")
      }
      else {
        var creditCardOptions = []
        var counter = 1
        var defaultCard = {}
        creditCardOptions[0] = {}
        creditCardOptions[0].value = "new"
        creditCardOptions[0].label = "Add New Card"
        res.credit_cards.forEach((cc) => {
          if(cc.default_card === true){
            defaultCard.value = cc.id
            defaultCard.label = cc.brand + " " +cc.last4
          }
          creditCardOptions[counter] = {}
          creditCardOptions[counter].value = cc.id
          creditCardOptions[counter].label = cc.brand + " " +cc.last4
          counter  = counter + 1
        })
        this.setState({
          creditCardOptions: creditCardOptions,
          creditCard: defaultCard,
        })
      }
    })
    .catch(err =>{
        alert(err);
    })
  }
  render() {
    const { textmask, numberformat } = this.state;
    const { classes } = this.props;
    var ccValue = null
    if (this.state.creditCard){
      ccValue = this.state.creditCard.value
    }
    const customStyles =
      this.state.width < 780 ?
      {
        content: {
          top                   : '25%',
          left                  : '0%',
          right                 : 'auto',
          bottom                : 'auto',
        }
      }:
        {
          content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            transform             : 'translate(-50%, -50%)'
          }
        }
      const newCCStyle =
        this.state.width < 780 ?
            {
              content: {
                top: '13%',
                left: '0%',
                width: '100%',
                height: '73%',
                right: 'auto',
              }
            }:
            {
              content: {
                top: '13%',
                left: '25%',
                right: '15%',
                height: '73%',
                width: '50%'
              }
            }
        const modalStyle =
          this.state.width < 780 ?
            {
              content: {
                top                   : '10%',
                left                  : '0%',
                height                : '80%',
                width                 : '80%',
                padding               : '0px',
                right                 : 'auto',
              }
            }:
            {
              content: {
                top                   : '10%',
                left                  : '35%',
                height                : '80%',
                width                 : '30%',
                padding               : '0px',
                right                 : 'auto',
              }
            }
        const customStyles2 =
            this.state.width < 780 ?
            {
              content: {
                top                   : '10%',
                left                  : '0%',
                height                : '70%',
                width                 : '100%',
                padding               : '0px',
                right                 : 'auto',
                color                 : 'white',
              }
            }:
              {
                content: {
                  top                   : '10%',
                  left                  : '15%',
                  height                : '62%',
                  width                 : '70%',
                  padding               : '0px',
                  right                 : 'auto',
                  color                 : 'white',
                }
              }
    var imageURL
    if(this.state.image && this.state.image.url){
      imageURL = this.state.image.url.url
      imageURL = imageURL.replace('http://', 'https://')
    }
    return (
      <div className="imageHolder">
        {this.state.image &&
          <div>
            <img className="giftcardImagePurchase" src={imageURL}></img>
            <div className="giftcardForm">
            <div>
                <TextField
                  id="amount"
                  value={this.state.amount}
                  label="Amount $"
                  onChange={this.handleChange('amount')}
                  margin="normal"
                 />
               </div>
               <br></br>
               <TextField
                 id="amount"
                 value={this.state.message}
                 onChange={this.handleChange('message')}
                 label="Add Message (optional)"
                 margin="normal"
                />
                <br></br>
                <TextField
                  id="amount"
                  value={this.state.sendAtFormatted}
                  defaultValue={this.state.sendAtFormatted}
                  onClick={this.showCalendar}
                  onChange={this.handleChange('sendAt')}
                  label="Send Later? (optional)"
                  InputLabelProps={{ shrink: this.state.shrink }}
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                 />
                 <br></br>
              </div>
              <br></br>
              <div className="giftcardForm" id="formLast">
              <h6 className="formSubheader">To:</h6>
              <TextField
                id="amount"
                value={this.state.name}
                onChange={this.handleChange('name')}
                label="Name"
                margin="normal"
               />
               <br></br>
               <TextField
                 id="amount"
                 value={this.state.email}
                 onChange={this.handleChange('email')}
                 label="Email"
                 margin="normal"
                />
                <br></br>
                  <TextField
                    error = {this.state.phoneError}
                    id="amount"
                    value={this.state.phone}
                    onChange={this.handleChange('phone')}
                    label="Phone Number"
                    margin="normal"
                   />

                 <br></br>

              </div>
              <Select
                  name="form-field-name"
                  className="ccSelect"
                  value={ccValue}
                  onChange={this.handleCCChange}
                  options={this.state.creditCardOptions}
                />

                <Modal
                  isOpen={this.state.newCCmodal}
                  contentLabel="Example Modal"
                  style={newCCStyle}
                  >
                  <div>
                    <div className="card-header blue-background text-white text-center dateTimeContainer ">
                      <h4>Add New Card</h4>
                    </div>
                    <NewCCForm ccErrors = {this.state.ccErrors} afterSave = {this.getCreditCards} closeModal={this.closeCCModal}/>
                  </div>

                </Modal>
                <Modal
                  style={modalStyle}
                  isOpen={this.state.modalIsOpen}
                  contentLabel="Example Modal">
                  <div className="card date-card">
                    <InfiniteCalendar
                      width={'100%'}
                      height={270}
                      minDate={new Date()}
                      onSelect={this.selectDate}
                    />
                  </div>
<button onClick = {() => this.closeModal()}className="btn btn-block calendarCancel text-center">Cancel</button>
                </Modal>
          <button id = "purchaseButton" className="btn newApptButton purchaseButton" onClick={() => this.createGiftcard()}>Purchase Gift Card</button>
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
        </div>
          }
          <Modal
            isOpen={this.state.loading}
            contentLabel="Example Modal"
            style={newCCStyle}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Loading</h4>
            </div>
            <div className="topDiv">
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={100}
                color={'#164070'}
                loading={this.state.loading}
              />
            </div>
          </Modal>
          <Modal
            isOpen={this.state.userInfoModalOpen}
            contentLabel="Example Modal"
            style={customStyles2}
            >
            <CustomerInfoForm error= {this.state.loginError} loginUser = {this.loginUser} saveUser = {this.saveUser} user={this.state.user}/>
          </Modal>
          <Modal
            isOpen={this.state.showConfirmationModal}
            contentLabel="Example Modal"
            style={customStyles}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Success</h4>
            </div>
            <div className="paddingTen">
              <p>Your Giftcard has been purchased!</p>
              <button className="btn btn-primary promoAdd" onClick={() => this.returnToDashboard()}>Close</button>
              <br></br>
            </div>
          </Modal>
      </div>
    )
}
}
export default NewGiftcard



// WEBPACK FOOTER //
// ./src/Components/NewGiftcard.js